/** Browser (desktop/tablet Chrome/Edge/Android Chrome) Notification helper. HTTPS required except localhost. */

const PREF_GRANTED_ONCE = 'portalNotifyUserOptIn'

export function notificationsSupported() {
  return typeof window !== 'undefined' && 'Notification' in window
}

export function notifyPermissionState() {
  if (!notificationsSupported()) return 'unsupported'
  return Notification.permission
}

export function rememberNotifyOptIn() {
  try {
    localStorage.setItem(PREF_GRANTED_ONCE, '1')
  } catch {
    /* noop */
  }
}

export function hasNotifyOptIn() {
  try {
    return localStorage.getItem(PREF_GRANTED_ONCE) === '1'
  } catch {
    return false
  }
}

/**
 * Ask for permission — must usually be triggered by a click/tap.
 * Returns 'granted' | 'denied' | 'default'
 */
export async function requestNotifyPermission() {
  if (!notificationsSupported()) return 'unsupported'
  try {
    const r = await Notification.requestPermission()
    if (r === 'granted') rememberNotifyOptIn()
    return r
  } catch {
    return 'denied'
  }
}

function shouldDeferToToast({ force }) {
  if (force) return false
  if (typeof document === 'undefined') return false
  return document.visibilityState === 'visible'
}

export function canShowBrowserNotification(options = {}) {
  if (!notificationsSupported()) return false
  if (Notification.permission !== 'granted') return false
  return !shouldDeferToToast(options)
}

/**
 * Shows a notification if permitted. When tab is visible, skips unless force (e.g. incoming call).
 * @returns {Notification|null}
 */
export function showBrowserNotification(title, body, options = {}) {
  const { tag, force, silent } = options
  if (!notificationsSupported() || Notification.permission !== 'granted') return null
  if (shouldDeferToToast({ force })) return null

  try {
    const n = new Notification(title, {
      body: body || '',
      tag: tag || 'portal-general',
      silent: Boolean(silent),
      icon:
        typeof window !== 'undefined'
          ? `${window.location.origin}/devbhumi-logo-icon.png`
          : undefined,
    })
    const url = typeof options.navigateTo === 'string' ? options.navigateTo : ''
    if (url || typeof options.navigateFn === 'function') {
      n.onclick = () => {
        try {
          window.focus()
          if (typeof options.navigateFn === 'function') options.navigateFn()
          else if (url) window.location.href = url
        } finally {
          n.close()
        }
      }
    }
    return n
  } catch {
    return null
  }
}
